// The help panel: one button on every screen, the screen's text from sv.ts.
import { sv } from '@aldorock-fordon/shared/sv';

export function HelpButton({
  screen,
  open,
  onToggle,
}: {
  screen: string;
  open: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      className="btn btn-quiet no-print"
      type="button"
      aria-expanded={open}
      aria-controls={`help-${screen}`}
      onClick={onToggle}
    >
      {open ? sv.help.close : sv.help.button}
    </button>
  );
}

export function HelpPanel({ screen }: { screen: string }) {
  const title = sv.help.title(sv.help.screens[screen] ?? screen);
  const body = sv.help.texts[screen] ?? '';
  return (
    <aside className="help-panel no-print" id={`help-${screen}`} aria-label={title}>
      <h2 className="help-title">{title}</h2>
      {body.split(/\n{2,}/).map((p, i) => (
        <p key={i}>{p}</p>
      ))}
    </aside>
  );
}
